/* eslint-disable import/no-unresolved */
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  Box,
  Button,
  Typography,
  Slide,
  Backdrop,
  Stack,
} from '@mui/material';
import Icon from '@/components/Icon';
import { selectModal } from '@/store/selectors';
import { closeModal } from '@/store/slices/modal';
import { logOut } from '@/store/slices/auth';
import { setAlert } from '@/store/slices/alert';

const boxStyle = {
  position: 'absolute',
  height: '400px',
  width: '800px',
  backgroundColor: '#fff',
  borderRadius: '10px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 2,
};
const Logout = () => {
  const { logout } = useSelector(selectModal);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(closeModal({ type: 'logout' }));
  };

  const handleLogOut = () => {
    dispatch(logOut());
    dispatch(closeModal({ type: 'logout' }));

    dispatch(
      setAlert({
        type: 'success',
        message: 'Successfully Logged Out',
      }),
    );
  };
  return (
    <div>
      <Modal
        open={logout}
        onClose={handleModalClose}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={logout} mountOnEnter unmountOnExit>
          <Box sx={boxStyle}>
            <Icon icon="disconnect" width={120} height={120} />
            <Typography
              variant="h5"
              sx={{ lineHeight: '16px', fontWeight: 500 }}
            >
              Are you sure you want to logout?
            </Typography>
            <Stack mt={10} width="210px" mx="auto" spacing={2}>
              <Button variant="contained" onClick={handleLogOut}>
                Yes
              </Button>
              <Button
                onClick={handleModalClose}
                variant="contained"
                sx={{
                  backgroundColor: (theme) => theme.general.cancel,
                  '&:hover': {
                    backgroundColor: '#922c18',
                  },
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default Logout;
